<div fxLayout="column" style="padding:15px;">

  <app-page-header [title]="pageTitle" action='newAffirmation'></app-page-header>

  <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:50px;">

    <div fxLayout="row" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;">

      <div fxFlex="grow" class="pageTitle" style="font-size: 22px;" fxLayoutAlign="start center center"></div>

      <div fxLayoutAlign="end center center"  #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
        <button mat-flat-button
                style="color: white; background:var(--primary); border:1px solid var(--primary); font-family: 'Century Gothic', sans-serif !important;">
          Ενέργειες
          <mat-icon style="vertical-align: middle; color:white;">
            {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
          </mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <mat-list>
            <mat-list-item class="menuList" (click)="navigateToActivities()">
              <button mat-menu-item ><mat-icon class="icon">nature_people</mat-icon>&nbsp; Δραστηριότητες</button>
            </mat-list-item>
            <mat-list-item class="menuList" (click)="navigateToActivitiesLevels()">
              <button mat-menu-item > <mat-icon class="icon">local_activity</mat-icon>&nbsp;Επίπεδα δραστηριοτήτων</button>
            </mat-list-item>
          </mat-list>
        </mat-menu>
      </div>
    </div>
  </div>

  <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:20px;">

    <div fxLayout="row wrap" style="margin-top:20px;">

      <!--      <div fxLayoutAlign="start center" fxFlex>-->
      <!--        <mat-form-field appearance="outline" style="font-family: 'Century Gothic', sans-serif !important;"-->
      <!--                        ngStyle.lt-md="width:100%;">-->
      <!--          <mat-label>Γρήγορη Αναζήτηση</mat-label>-->
      <!--          <label>-->
      <!--            <input matInput [(ngModel)]="formSearchValue" (keydown)="searchForms()" ngStyle.lt-md="width:100%;"/>-->
      <!--          </label>-->
      <!--        </mat-form-field>-->
      <!--      </div>-->

      <!--      <div fxLayout="row" fxLayoutAlign="end center" fxFlex.lt-md="100" fxFlex.gt-sm="35" ngStyle.gt-sm="margin-left:10px;">-->
      <!--        <mat-form-field appearance="outline" style="font-family: 'Century Gothic', sans-serif !important;"-->
      <!--                        ngStyle.lt-md="width:100%;">-->
      <!--          <mat-label>Αναζητήση βάση κατηγορίας</mat-label>-->
      <!--          <mat-select multiple [(ngModel)]="selectedCategory" (selectionChange)="checkCategory($event)"-->
      <!--                      style="font-family: 'Century Gothic', sans-serif !important; font-size: 12px !important;"-->
      <!--                      ngStyle.lt-md="width:100%;">-->
      <!--            <mat-option style="font-family: 'Century Gothic', sans-serif !important;"-->
      <!--                        *ngFor="let category of categoryTypes"-->
      <!--                        [value]="category" [disabled]="category.disabled">{{category.description}}</mat-option>-->
      <!--          </mat-select>-->
      <!--        </mat-form-field>-->
      <!--      </div>-->
    </div>


    <mat-divider ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;"></mat-divider>

  </div>
</div>


